import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'
import { IcosInput } from './input'
import { FormsModule } from '@angular/forms'
import { IcosFormItem } from '../form/form-item'


@NgModule({
  declarations: [IcosInput],
  exports: [IcosInput],
  imports: [CommonModule, FormsModule],
  entryComponents: [IcosInput],
})
export class IcosInputsModule {
  static forRoot(): ModuleWithProviders {
    return { ngModule: IcosInputsModule, providers: [ IcosFormItem ] }
  }
}
